import { QueryClient } from "@tanstack/react-query";
import { createRouter } from "@tanstack/react-router";
import { routeTree } from "./routeTree.gen";

export const getRouter = () => {
  const queryClient = new QueryClient();

  const router = createRouter({
    routeTree,
    context: { queryClient },
    scrollRestoration: true,
    defaultPreloadStaleTime: 0,
    // Fetches a link's route chunk (and loader data) as soon as the pointer
    // rests on it, so by the time the click lands the navigation is often
    // already resolved instead of only starting then — this is most of why
    // clicking a nav link or menu item felt like it "jumped" with a delay.
    defaultPreload: "intent",
    defaultPreloadDelay: 50,
  });

  return router;
};
